var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYaSplitLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 17,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ya-split-logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#01B94F",
  d: "m8.5 8.5 6.002 6.058-.194.175A8.52 8.52 0 0 1 2.69 2.267c2.513-1.275 8.784-3.038 11.964.362z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__b)",
  d: "M2.7 2.267C5.24.95 11.473-.771 14.66 2.627c0 0-5.99 5.744-6.186 5.894-.01.007.895.94.884.948l5.134 5.063-.197.174c-3.49 3.089-8.844 2.975-12.022-.436A8.534 8.534 0 0 1 2.7 2.267"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__c)",
  d: "M2.704 2.257c2.55-1.352 8.765-3.026 11.956.37 0 0-5.82 5.617-6.213 5.917-.02.014.85.93.83.948l5.205 5.015-.198.175c-3.481 3.077-8.835 2.955-12.004-.443s-2.989-8.816.424-11.982"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__d)",
  d: "M2.709 2.254C5.284.86 11.475-.768 14.66 2.628c0 0-5.65 5.488-6.233 5.939-.03.022.809.923.776.947l5.274 4.969-.197.174c-3.472 3.067-8.824 2.938-11.986-.45-3.162-3.39-2.99-8.797.414-11.953"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__e)",
  d: "M2.712 2.25c2.596-1.434 8.763-3.018 11.949.378.007.008-5.479 5.362-6.268 5.961-.04.03.767.915.723.948 0 0 5.345 4.92 5.345 4.922l-.197.174c-3.465 3.057-8.816 2.92-11.97-.46-3.153-3.378-2.979-8.777.418-11.923"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__f)",
  d: "M2.716 2.247c2.618-1.475 8.75-3.013 11.946.38.009.01-5.31 5.243-6.297 5.985-.048.037.724.908.67.948 0 0 5.416 4.873 5.415 4.874l-.196.173c-3.456 3.047-8.806 2.903-11.952-.464s-2.976-8.76.414-11.896"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__g)",
  d: "M2.72 2.243c2.64-1.516 8.745-3.008 11.942.385.01.013-5.14 5.107-6.324 6.007-.058.045.682.9.617.949l5.485 4.825-.197.174c-3.448 3.036-8.796 2.886-11.935-.473S-.665 5.37 2.72 2.243"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__h)",
  d: "M2.724 2.24c2.659-1.558 8.74-3.003 11.938.388.013.014-4.97 4.981-6.351 6.03-.068.052.639.892.567.949 0 0 5.556 4.777 5.554 4.778l-.195.173c-3.44 3.026-8.783 2.869-11.919-.48-3.135-3.35-2.975-8.721.406-11.838"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__i)",
  d: "M2.729 2.235c2.68-1.598 8.735-2.997 11.933.393.015.017-4.798 4.853-6.374 6.052-.078.06.595.884.508.949 0 0 5.627 4.73 5.626 4.732l-.196.172c-3.432 3.015-8.783 2.85-11.9-.488-3.116-3.34-2.972-8.701.403-11.81"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__j)",
  d: "M2.733 2.233c2.7-1.64 8.73-2.995 11.93.395.015.02-4.629 4.726-6.405 6.075-.088.068.552.877.454.949 0 0 5.698 4.682 5.695 4.685l-.194.173c-3.424 3.003-8.769 2.833-11.884-.496S-.636 5.33 2.733 2.233"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__k)",
  d: "M2.735 2.228c2.723-1.681 8.725-2.989 11.928.4.017.021-4.46 4.598-6.433 6.092-.098.075.51.868.4.95 0 0 5.768 4.634 5.767 4.636l-.196.172c-3.415 2.994-8.758 2.815-11.866-.503s-2.962-8.657.4-11.747"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__l)",
  d: "M2.739 2.224c2.742-1.721 8.72-2.983 11.924.404.018.024-4.289 4.472-6.46 6.121-.108.081.466.86.347.95 0 0 5.838 4.587 5.835 4.588l-.194.173c-3.407 2.982-8.75 2.796-11.849-.511s-2.96-8.645.397-11.725"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__m)",
  d: "M2.743 2.221c2.764-1.763 8.716-2.975 11.92.407.021.026-4.118 4.345-6.487 6.144-.117.088.425.85.294.95 0 0 5.909 4.533 5.906 4.541l-.194.172c-3.4 2.975-8.74 2.779-11.834-.518s-2.955-8.626.395-11.696"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__n)",
  d: "M2.748 2.217c2.784-1.803 8.71-2.975 11.916.41.022.03-3.948 4.218-6.517 6.168-.126.096.381.85.24.949 0 0 5.98 4.492 5.975 4.495l-.196.171c-3.391 2.961-8.729 2.763-11.815-.525-3.085-3.288-2.949-8.607.397-11.668"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__o)",
  d: "M2.752 2.214C5.557.373 11.456-.76 14.665 2.628c.024.03-3.78 4.09-6.542 6.19-.142.103.337.835.185.948 0 0 6.05 4.445 6.047 4.447l-.189.172c-3.383 2.952-8.72 2.745-11.798-.533s-2.956-8.586.384-11.638"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__p)",
  d: "M2.755 2.21c2.834-1.887 8.7-2.965 11.91.425.026.033-3.608 3.967-6.569 6.212-.141.11.295.829.132.95 0 0 6.12 4.392 6.117 4.4l-.194.17c-3.376 2.942-8.711 2.728-11.781-.539-3.091-3.296-2.948-8.576.385-11.618"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__q)",
  d: "M2.759 2.207c2.847-1.928 8.695-2.96 11.9.425.028.034-3.438 3.837-6.596 6.234-.156.119.25.82.078.95 0 0 6.19 4.35 6.186 4.352l-.192.17c-3.368 2.931-8.701 2.71-11.759-.547-3.085-3.282-2.943-8.55.383-11.584"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__r)",
  d: "M2.764 2.203c2.868-1.97 8.69-2.955 11.9.425.03.037-3.269 3.709-6.623 6.257-.166.126.208.813.024.95 0 0 6.26 4.302 6.257 4.306l-.192.167C10.766 17.231 5.438 17 2.383 13.756c-3.079-3.273-2.941-8.53.38-11.553"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__s)",
  d: "M2.768 2.199c2.889-2.01 8.684-2.95 11.9.425.031.04-3.1 3.582-6.651 6.28-.176.133.165.804-.03.95 0 0 6.331 4.25 6.327 4.257-.027.026-.166.142-.193.17-3.35 2.91-8.681 2.675-11.73-.566-3.074-3.253-2.94-8.502.377-11.516"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__t)",
  d: "M2.772 2.196c2.91-2.054 8.679-2.947 11.895.432.032.041-2.929 3.455-6.679 6.303-.185.141.122.797-.083.95 0 0 6.402 4.208 6.397 4.21l-.192.17c-3.344 2.9-8.673 2.657-11.713-.566-3.067-3.257-2.937-8.496.375-11.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__u)",
  d: "M2.775 2.192C5.705.099 11.45-.75 14.666 2.628c.034.044-2.758 3.328-6.705 6.325-.195.142.08.79-.142.952 0 0 6.472 4.158 6.468 4.163l-.192.168c-3.329 2.889-8.658 2.64-11.687-.577-3.064-3.244-2.938-8.473.367-11.467"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__v)",
  d: "M2.779 2.189c2.952-2.134 8.67-2.937 11.887.44.037.044-2.588 3.2-6.732 6.347-.205.156.037.782-.191.952 0 0 6.542 4.108 6.538 4.115l-.193.169c-3.322 2.877-8.653 2.622-11.68-.584-3.052-3.237-2.929-8.454.37-11.44"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__w)",
  d: "M2.783 2.185C5.758.01 11.448-.747 14.668 2.629c.037.047-2.42 3.073-6.76 6.375-.216.165 0 .774-.246.952 0 0 6.613 4.063 6.608 4.069l-.191.167c-3.313 2.862-8.644 2.6-11.661-.592-3.049-3.231-2.928-8.44.365-11.415"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__x)",
  d: "M2.788 2.182c2.993-2.216 8.658-2.927 11.88.447.04.048-2.248 2.946-6.787 6.392-.226.172-.05.767-.3.952 0 0 6.683 4.016 6.679 4.02l-.191.174c-3.311 2.857-8.635 2.586-11.645-.6-3.042-3.225-2.924-8.42.364-11.385"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__y)",
  d: "M2.792 2.177c3.016-2.256 8.655-2.922 11.876.452.041.051-2.078 2.818-6.814 6.416-.235.178-.094.757-.354.951 0 0 6.754 3.967 6.749 3.974l-.19.167c-3.304 2.847-8.626 2.57-11.628-.605-3.036-3.212-2.923-8.398.361-11.355"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__z)",
  d: "M2.797 2.175c3.034-2.3 8.648-2.919 11.871.454.044.053-1.908 2.692-6.84 6.44-.246.185-.142.749-.409.951 0 0 6.826 3.92 6.82 3.926l-.191.167c-3.294 2.833-8.615 2.55-11.61-.614-3.029-3.201-2.92-8.378.359-11.324"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__A)",
  d: "M2.798 2.17c3.058-2.339 8.642-2.912 11.87.46.045.055-1.738 2.564-6.869 6.46-.255.193-.178.742-.462.953 0 0 6.895 3.873 6.89 3.879-.039.034-.15.133-.19.165-3.287 2.834-8.606 2.536-11.593-.62-3.023-3.193-2.917-8.358.354-11.297"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__B)",
  d: "M2.803 2.166C5.88-.214 11.445-.74 14.669 2.63c.047.057-1.568 2.437-6.896 6.484-.265.2-.223.733-.516.953 0 0 6.966 3.824 6.96 3.824l-.193.173c-3.275 2.815-8.593 2.512-11.572-.627-3.02-3.185-2.914-8.336.351-11.27"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__C)",
  d: "M2.807 2.163c3.098-2.422 8.642-2.902 11.862.466.048.06-1.399 2.31-6.923 6.507-.274.208-.265.725-.567.952 0 0 7.037 3.778 7.03 3.784-.042.038-.142.13-.19.167-3.27 2.804-8.587 2.5-11.558-.636-3.014-3.176-2.914-8.321.346-11.24"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__D)",
  d: "M2.812 2.159c3.116-2.462 8.629-2.899 11.857.47.05.063-1.228 2.188-6.95 6.53-.283.215-.307.717-.623.952 0 0 7.106 3.731 7.1 3.737l-.19.166c-3.258 2.793-8.576 2.482-11.541-.643C-.54 10.2-.442 5.069 2.812 2.159"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__E)",
  d: "M2.816 2.156c3.133-2.504 8.623-2.894 11.853.473.052.064-1.057 2.056-6.977 6.552-.293.223-.352.709-.677.954 0 0 7.177 3.683 7.17 3.683l-.189.172c-3.258 2.783-8.568 2.463-11.525-.65-2.997-3.16-2.905-8.284.345-11.184"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__F)",
  d: "M2.819 2.152c3.16-2.55 8.619-2.889 11.852.477.052.067-.888 1.928-7.006 6.575-.299.231-.393.701-.724.954 0 0 7.248 3.635 7.241 3.64l-.188.166c-3.247 2.774-8.558 2.447-11.508-.657-3-3.15-2.911-8.265.333-11.155"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__G)",
  d: "M2.822 2.149c3.182-2.587 8.615-2.884 11.848.48.055.068-.718 1.8-7.032 6.598-.313.238-.437.694-.785.953 0 0 7.317 3.589 7.31 3.594-.047.044-.142.124-.188.166-3.238 2.763-8.549 2.428-11.49-.666-2.986-3.14-2.9-8.245.337-11.125"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__H)",
  d: "M2.833 2.145c3.203-2.628 8.609-2.879 11.843.484.057.071-.548 1.675-7.059 6.62-.329.243-.486.686-.844.951 0 0 7.388 3.542 7.38 3.542-.05.043-.141.121-.188.164-3.23 2.752-8.538 2.408-11.475-.671-2.978-3.124-2.894-8.219.343-11.09"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__I)",
  d: "M2.833 2.14c3.221-2.667 8.602-2.874 11.838.49.06.072-.377 1.546-7.084 6.642-.333.252-.522.679-.892.954 0 0 7.458 3.493 7.45 3.5-.05.045-.142.12-.187.164-3.226 2.742-8.533 2.402-11.46-.68-2.973-3.123-2.892-8.206.335-11.07"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__J)",
  d: "M2.833 2.138c3.247-2.705 8.6-2.87 11.839.491.06.075-.209 1.417-7.115 6.666-.343.26-.566.67-.946.955 0 0 7.528 3.444 7.521 3.45-.052.049-.142.12-.187.165-3.214 2.731-8.52 2.377-11.44-.69-2.966-3.117-2.89-8.186.328-11.037"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__K)",
  d: "M2.833 2.133C6.1-.617 11.428-.73 14.667 2.63c.062.077-.039 1.292-7.142 6.688-.353.268-.609.663-1 .955 0 0 7.6 3.4 7.59 3.4a7 7 0 0 1-.186.165c-3.206 2.72-8.51 2.358-11.422-.696-2.955-3.101-2.883-8.164.326-11.008"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__L)",
  d: "M2.843 2.125c3.286-2.792 8.589-2.86 11.829.499.063.079.131 1.166-7.169 6.71-.362.275-.651.655-1.054.955 0 0 7.67 3.35 7.662 3.358l-.187.163c-3.198 2.711-8.5 2.341-11.404-.709-2.956-3.084-2.886-8.143.322-10.976"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__M)",
  d: "M2.848 2.125c3.306-2.833 8.583-2.853 11.824.504.067.082.304 1.039-7.195 6.735-.372.283-.695.646-1.108.954 0 0 7.74 3.302 7.731 3.31a7 7 0 0 1-.185.163c-3.19 2.7-8.492 2.323-11.388-.708-2.952-3.09-2.882-8.125.32-10.958"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__N)",
  d: "M2.852 2.125c3.327-2.876 8.578-2.853 11.822.504.066.084.471.911-7.225 6.758-.381.283-.737.637-1.16.955 0 0 7.81 3.258 7.801 3.258a7 7 0 0 1-.186.163c-3.179 2.692-8.481 2.306-11.37-.717-2.944-3.075-2.88-8.109.318-10.921"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__O)",
  d: "M2.855 2.125a8.613 8.613 0 0 1 11.818.51c.068.086.642.783-7.252 6.78-.39.296-.779.63-1.214.955 0 0 7.881 3.206 7.873 3.214q-.092.082-.187.163c-3.172 2.682-8.472 2.29-11.354-.724-2.935-3.077-2.876-8.099.316-10.898"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__P)",
  d: "M14.069 13.555c-3.141 2.846-8.591 2.493-11.522-.567s-2.873-8.075.312-10.869a8.57 8.57 0 0 1 11.815.513c.073.092.888.709-8.547 7.758 0-.003 7.95 3.156 7.942 3.165"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__Q)",
  d: "M11.002 6.592a120 120 0 0 1-4.743 3.697c1.56 1.618 3.233 2.927 4.741 3.713 1.51.787 2.713.948 3.283.434s.504-1.7-.179-3.242c-.631-1.435-1.724-3.048-3.102-4.602"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ya-split-logo_svg__R)",
  d: "m11.123 6.491-.036.03-.336.279c1.297 1.465 2.373 3.067 2.963 4.41.647 1.476.773 2.498.354 2.879-.466.425-1.65.238-3.01-.475-1.426-.745-3.018-2.006-4.496-3.556l-.436.328c3.117 3.24 6.538 5.1 8.02 4.422q.063-.03.124-.068l.017-.01a1.1 1.1 0 0 0 .3-.276c.956-1.26-.528-4.656-3.464-7.963"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.027 15q-2.33 0-3.68-1.69Q20 11.6 20 8.51q0-3.019 1.33-4.765Q22.678 2 25.19 2q.874 0 1.567.255.692.236 1.13.545v1.764a7.4 7.4 0 0 0-1.167-.582 3.8 3.8 0 0 0-1.42-.273q-1.603 0-2.332 1.182t-.729 3.618q0 2.364.73 3.582.728 1.2 2.221 1.2.874 0 1.512-.255.638-.272 1.184-.672v1.763q-.42.291-1.13.582t-1.73.291M29.258 5.673h7.14v9.145h-2.167V7.382h-2.805v7.436h-2.168zM37.495 12.946l.128.09a.75.75 0 0 0 .364.073q.528 0 .692-.545.164-.546.219-2l.182-4.891h6.211v9.145h-2.167V7.382h-2.205l-.127 3.273q-.073 2.273-.565 3.309-.492 1.035-1.876 1.036-.382 0-.62-.09l-.236-.092zM47.118 5.673h2.113v5.654l3.351-5.654h1.876v9.145h-2.112V9.164l-3.352 5.654h-1.876zM63 7.382h-2.55v7.436h-2.168V7.382h-2.55v-1.71H63z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-2.291 43.79 -264.371)scale(37.4469 27.7113)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#03BA50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01B64E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-2.291 43.412 -264.274)scale(37.3973 27.6746)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#04BC50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01B34D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__d",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.31786 -1.49271 1.10463 27.61582 10.594 1.509)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#06BD51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#02B24C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01B04B"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.2683 -1.49073 1.10317 27.57915 10.586 1.495)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#08BF52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#04B44D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01AD4A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.22014 -1.4888 1.10174 27.54347 10.58 1.483)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0AC053"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#05B54E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01AA49"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__g",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-2.291 42.127 -263.612)scale(37.2002 27.5288)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0BC253"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#07B74E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01A848"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__h",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.1223 -1.11367 .82438 27.47924 10.56 1.51)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0DC354"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#08B84F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01A546"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__i",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.07422 -1.11223 .8233 27.44355 10.548 1.494)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0FC555"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#0ABA50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01A245"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__j",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.3948 -1.11073 .81374 27.39602 10.738 1.48)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#11C656"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#0CBB51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#019F44"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__k",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.701 54.829 -360.744)scale(37.3627 27.3724)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#12C856"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#0EBD51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#029E44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#019C43"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__l",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.29755 -1.10785 .81162 27.32475 10.731 1.457)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#14C957"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#0FBE52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#049F44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#019941"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__m",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.24887 -1.1064 .81056 27.28906 10.726 1.447)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#16CB58"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#11C053"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#06A145"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#019640"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__n",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.2002 -1.10495 .8095 27.25348 10.72 1.44)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#18CC59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#13C154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#07A246"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01933F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__o",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.15161 -1.10351 .80845 27.2178 10.712 1.435)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#19CD59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#15C254"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#09A347"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01903E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__p",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.701 53.515 -359.68)scale(37.1207 27.1952)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1BCF5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#17C455"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#0BA547"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#018D3C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__q",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.05576 -1.10066 .80636 27.14763 10.692 1.434)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1DD05B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#18C556"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#0CA648"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#018B3B"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__r",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.701 53.606 -358.95)scale(37.0248 27.125)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1ED25B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#1AC756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#0EA848"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#01883A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__s",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.95985 -.73188 .5363 27.0834 10.668 1.382)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#20D35C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#1BC857"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#0FA949"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#018539"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__t",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.134 74.858 -537.316)scale(36.9199 27.0541)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#22D55D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#1DCA58"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#11AB4A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#018237"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__u",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.86397 -.72998 .53491 27.0131 10.637 1.372)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#24D65E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#1FCB59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#13AC4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#017F36"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__v",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.134 74.438 -535.649)scale(36.824 26.9838)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#25D85E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#20CD59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#14AE4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#017D36"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#007C35"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__w",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.7696 -.72811 .53354 26.94392 10.601 1.368)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#27D95F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#22CE5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#16AF4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#027E36"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#007934"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__x",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(37.08597 -.72717 .52763 26.90943 10.484 1.368)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#29DB60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#24D05B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#18B14D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#048037"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#007632"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__y",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.123 75.075 -532.501)scale(37.0454 26.88)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2BDC61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#26D15C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#1AB24E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#068138"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#007331"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__z",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.99059 -.7253 .52614 26.83304 10.935 1.374)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2CDE61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#27D35C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#1BB44E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#088339"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#007030"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__A",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.123 75.864 -556.377)scale(36.95 26.8036)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2EDF62"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#29D45D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#1DB54F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#098439"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#006E2F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__B",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.123 76.218 -555.76)scale(36.9023 26.769)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#30E163"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#2BD65E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#1FB750"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#0B8639"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#006B2D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__C",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-1.123 76.7 -554.966)scale(36.856 26.7355)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#31E263"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#2CD75E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#20B850"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#0D873A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#00682C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__D",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.80123 -.3608 .26176 26.69992 10.878 1.253)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#33E364"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#2ED85F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#22B951"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#0E883B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#00652B"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__E",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-.562 133.665 -1107.22)scale(36.7553 26.6666)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35E565"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#30DA60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#24BB52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#108A3C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#00622A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__F",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.70734 -.35988 .2611 26.63182 10.845 1.262)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#37E666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#32DB61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#26BC53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#128B3C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#005F28"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__G",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-.562 134.72 -1103.482)scale(36.6629 26.5995)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#38E866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#33DD61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#27BE53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#148D3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#005C27"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__H",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-.562 135.542 -1101.387)scale(36.6152 26.5649)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3AE967"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#35DE62"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#29BF54"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#158E3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#005926"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__I",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.56714 -.3585 .2601 26.53013 10.783 1.288)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3CEB68"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#37E063"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2BC155"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#17903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#005625"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__J",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-.562 137.763 -1097.051)scale(36.5227 26.4978)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3EEC69"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#39E164"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2DC256"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#19913F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#005323"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__K",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-.562 139.2 -1094.81)scale(36.4764 26.4643)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3FEE69"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#3AE364"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#2EC456"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#1A9340"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#005122"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__L",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-.556 141.92 -1079.699)scale(36.7888 26.4318)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#41EF6A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#3CE465"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#30C557"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#1C9441"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#015022"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#004E21"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__M",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.74187 -.35672 .2563 26.39806 10.456 1.344)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43F16B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#3EE666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#32C758"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#1E9642"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#035223"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#004B20"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__N",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.69947 -.3563 .256 26.36756 10.425 1.363)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#45F26C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#40E767"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#34C859"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#209742"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#055323"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#00481E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__O",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.6528 0 0 26.3331 10.393 1.129)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46F46C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#41E967"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#35CA59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#229943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#065524"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#00451D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ya-split-logo_svg__P",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(36.6076 0 0 26.3006 11.208 1.141)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48F56D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#43EA68"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#37CB5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#239A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#085625"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#00421C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ya-split-logo_svg__Q",
  x1: 11.678,
  x2: 8.537,
  y1: 20.421,
  y2: -2.078,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#FF8475"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#E84E43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#D6261F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#CC0E08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#C80500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ya-split-logo_svg__R",
  x1: 14.449,
  x2: 8.853,
  y1: 14.592,
  y2: 8.075,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9EF0BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#55D48C"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ya-split-logo_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 17,
  fill: "#fff",
  rx: 7.802
})))));
export default SvgYaSplitLogo;